$('document').ready(function () {
  // get code
  var isSubmit = false
  // isShow pop
  if ($.cookie('new-popup') === undefined && $('#popup-new-email'.length === 1)) {
    setTimeout(function() {
      $('.popup-new-email').css('display', 'flex')
      startDown()
      $.cookie('new-popup', 1, { expires: 1 })
      clearTimeout()
    }, 5000)
  }
  // $('.popup-new-email').css('display', 'flex')
  // startDown()
  // close pop
  $('#popup-new-close').click(function() {
    $('.popup-new-email').css('display', 'none')
  })

  function initCode(param) {
    $.ajax({  
      type: "GET", 
      url: "https://api.melodysusie.com/api/v1/defaultCode?shop=melodysusie.myshopify.com",  
      contentType: 'application/x-www-form-urlencoded;charset=utf-8', 
      dataType: "json",  
      success: function(res){
        closeLoading()
        $('#new_email_code').html(res.data.code)
        $('.popup-new-two').css('display', 'block')
        $('.popup-new-one').css('display', 'none')
        const params = {
          email: param.email,
          code: res.data.code
        }
        gio('track', 'newsLetterPopup', { 'emailAddress_var': param.email })
        sendEmail(params)
      },
      error:function(error){  
        console.log(error)
      }  
    })
  }
  // send email
  function sendEmail(params) {
    $.ajax({  
      type: "POST", 
      url: "https://api.melodysusie.com/api/v1/email/subscribe",  
      contentType: 'application/x-www-form-urlencoded;charset=utf-8',
      data: params, 
      dataType: "json",  
      success: function(res){
        console.log('email send!')
      },
      error:function(error){  
        console.log(error)
      }  
    })
  }
  function closeLoading() {
    isSubmit = false
    $('.pswp__preloader__icn_box').css('display', 'none')
  }
  // submit email
  $('#popup-submit').click(function() {
    if (isSubmit) {
      return false
    }
    isSubmit = true
    $('.pswp__preloader__icn_box').css('display', 'block')
    var email =  $('#popupEmailFrom').val()
    const param = {
      email: email
    }
    // reset tip
    $('.news_email_tip').css('opacity', 0)
    $.ajax({  
      type: "POST", 
      url: "https://service.infiai.tech/ms_popup/check_user",  
      contentType: 'application/x-www-form-urlencoded;charset=utf-8',
      data: param,  
      dataType: "json",  
      success: function(res){
        if (res.code === 200) {
          initCode(param)
        } else if (res.code === 400) {
          closeLoading()
          $('.news_email_tip').css('opacity', 1)
        } else if (res.code === 403) {
          closeLoading()
          $('.popup-new-three').css('display', 'block')
          $('.popup-new-one').css('display', 'none')
        }
      },
      error:function(error){  
        console.log(error)
      }  
    })
  })
  // countdown
  function timer(intDiff){
    window.setInterval(function(){
    var day=0,
      hour=0,
      minute=0,
      second=0;		
  
    if(intDiff > 0){
      day = Math.floor(intDiff / (60 * 60 * 24));
      hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
      minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
      second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    }
    if (hour <= 9) hour = '0' + hour; 
    if (minute <= 9) minute = '0' + minute;
    if (second <= 9) second = '0' + second;
    $('#day_show').html(day);
    $('#hour_show').html('<s id="h"></s>'+hour);
    $('#minute_show').html('<s></s>'+minute);
    $('#second_show').html('<s></s>'+second);
    $('#day_show2').html(day);
    $('#hour_show2').html('<s id="h"></s>'+hour);
    $('#minute_show2').html('<s></s>'+minute);
    $('#second_show2').html('<s></s>'+second);
    intDiff--;
    }, 1000);
  }
  // start countdown
  function startDown (){
    if ($('#popup-new-email-date').length === 1) {
      const date = $('#popup-new-email-date').val()
      var intDiff = (new Date(date).getTime() - new Date().getTime()) / 1000
      if (intDiff > 0 ) {
        timer(intDiff)
      }
    }
  }
  // copy-fs
  function copyText(text) {
    var textarea = document.createElement("input");//
    var currentFocus = document.activeElement;//
    document.body.appendChild(textarea);//
    textarea.value = text;
    textarea.focus();
    if(textarea.setSelectionRange)
      textarea.setSelectionRange(0, textarea.value.length);//
    else
      textarea.select();
    try {
      var flag = document.execCommand("copy");//
    } catch(eo) {
      var flag = false;
    }
    document.body.removeChild(textarea);//
    currentFocus.focus();
    return flag;
  }

  $('#new_email_copy').click(function() {
    var codeText =  $('#new_email_code').text()
    copyText(codeText)
    $('#new_email_copy').html('Copied')
  })
})